<template>
  <div
    id="multiSensorHiL"
    :class="{
      box: true,
      'landscape-box': isLandscape,
      'portrait-box': !isLandscape,
      en: $i18n.locale === 'en-US',
    }"
  >
    <!-- <div id="multiSensorHiL"> -->
    <div
      id="multiSensorHiLModule1"
      :style="{ 'background-image': 'url(' + imageUrl1 + ')' }"
      v-lazy="imageUrl1"
    >
      <div id="multiSensorHiLModule1Text" class="gaiAModule1">
        <div
          id="multiSensorHiLModule1TextText1"
          class="module1 pre-wrap"
          v-text="`${$t(`${i18nKey}.title`)}`"
        ></div>
        <div id="multiSensorHiLModule1TextText2" class="module1">
          {{ $t(`${i18nKey}.subtitle`) }}
        </div>
      </div>
    </div>
    <!-- hercules -->
    <div class="hercules">
      <div class="left wow animate__animated animate__fadeInUp">
        <div class="h1">{{ $t(`${i18nKey}.intro.title`) }}</div>
        <div class="h2">
          {{ $t(`${i18nKey}.intro.content`) }}
        </div>
      </div>
      <div class="right wow animate__animated animate__fadeInUp">
        <img src="@/static/img/hercules.png" alt="" srcset="" />
      </div>
    </div>
    <!-- 我们的特点 -->
    <div class="ourFuture">
      <div class="cont">
        <div class="title wow animate__animated animate__fadeInUp">
          {{ $t(`${i18nKey}.feature.title`) }}
        </div>
        <ul>
          <li
            ref="liRef"
            class="wow animate__animated animate__fadeInUp"
            v-for="(item, index) in $t(`${i18nKey}.feature.list`)"
            :key="index"
          >
            <div class="img">
              <img :src="item.icon" alt="" />
            </div>
            <div class="h1">{{ item.h1 }}</div>
            <div class="h2">{{ item.h2 }}</div>
          </li>
        </ul>
      </div>
    </div>

    <div id="multiSensorHiLFooter">
      <FooterComponents></FooterComponents>
    </div>
  </div>
</template>

<script>
import FooterComponents from "@/components/FooterComponents.vue";
import WOW from "wowjs";

export default {
  computed: {
    isLandscape() {
      return Math.abs(window.orientation) === 90;
    },
  },
  components: {
    FooterComponents,
  },
  updated() {
    let lang = localStorage.getItem("lang");
    if (lang == "en-US") {
      this.showTestObject = false;
    } else {
      this.showTestObject = true;
    }
  },
  data() {
    return {
      i18nKey: "productCenterHerculesView",
      imageUrl1: require("@/static/img/herciles_bg.png"),
      imageUrl2: require("@/static/img/HiLBox.png"),
      imageUrl3: require("@/static/img/HiLArrow.png"),
      imageUrl4: require("@/static/img/HilColorCol.png"),
      imageUrl5: require("@/static/img/HilColorBox.png"),
      imageUrl6: require("@/static/img/HiLRowBg.png"),
      imageUrl7: require("@/static/img/HiLProductBg.png"),
      showTestObject: true,
      futureList: [
        {
          icon: require("@/static/img/futureIcon2.svg"),
          h1: "高拓展性",
          h2: "硬件系统基于模块化设计，具有较好的扩展性",
        },
        {
          icon: require("@/static/img/futureIcon1.svg"),
          h1: "高精度时钟同步",
          h2: "通过 PCIE 总线提供高精度软硬件时钟同步",
        },
        {
          icon: require("@/static/img/futureIcon4.svg"),
          h1: "高性价比",
          h2: "国际大厂代工的高性能板卡",
        },
        {
          icon: require("@/static/img/futureIcon3.svg"),
          h1: "高效的管理大屏",
          h2: "实现数据实时采集、记录、监控、配置，提高使用便捷性与效率",
        },
        {
          icon: require("@/static/img/futureIcon7.svg"),
          h1: "丰富的接口形式",
          h2: "支持CAN、LIN、车载以太网、以太网通讯以及通用I/O接口仿真，支持LVDS功能扩展",
        },
        {
          icon: require("@/static/img/futureIcon5.svg"),
          h1: "灵活的自动化测试",
          h2: "支持在自动化测试序列中嵌入Python脚本语言，以实现复杂的测试步骤",
        },
        {
          icon: require("@/static/img/futureIcon6.svg"),
          h1: "直观的接口映射匹配",
          h2: "在树状拓扑结构中可将系统中的变量与硬件接口进行映射匹配",
        },
      ],
    };
  },
  created() {
    const reloadOnOrientationChange = () => {
      const isLandscape = Math.abs(window.orientation) === 90;
      if (isLandscape) {
        location.reload();
      } else {
        location.reload();
      }
    };
    window.addEventListener("orientationchange", reloadOnOrientationChange);
  },
  mounted() {
    let lang = localStorage.getItem("lang");
    if (lang == "en-US") {
      this.showTestObject = false;
    } else {
      this.showTestObject = true;
    }
    const wow = new WOW.WOW({
      live: false,
    });
    wow.init();
    let liElementArr = this.$refs.liRef;
    liElementArr.forEach((item, index) => {
      item.style.animationDuration = (index + 1) * 0.3 + "s";
    });
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.landscape-box {
  /* 横屏 */
  /* display: flex;
    flex-direction: column; */
}

.portrait-box {
  /* 竖屏 */
  display: flex;
  flex-direction: column;
}

#multiSensorHiL {
  width: 100%;
  height: 100%;

  @mixin whar($width, $height, $atio) {
    width: $width;
    height: $height;
    aspect-ratio: $atio;
    box-sizing: border-box;
  }

  @mixin bgar($atio) {
    text-align: center;
    margin-right: 1.5rem;
    aspect-ratio: $atio;
    background-size: contain;
    background-repeat: no-repeat;
  }

  @mixin display {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @mixin commitaspct {
    opacity: 1;
    width: 50%;
    aspect-ratio: 720/600;
    background-size: contain;
    background-repeat: no-repeat;
  }

  @mixin fontStyle(
    $fontweight,
    $height,
    $fontSize,
    $lineHeight,
    $letterSpaceing,
    $color
  ) {
    width: fit-content;
    font-weight: $fontweight;
    height: $height;
    font-size: $fontSize;
    font-style: normal;
    line-height: $lineHeight;
    letter-spacing: $letterSpaceing;
    color: $color;
  }

  #multiSensorHiLModule1 {
    background-size: cover;
    @include whar(100%, auto, 1440/480);
    padding: 12.9375rem 0rem 11rem 12.8125rem;

    #multiSensorHiLModule1Text {
      width: fit-content;
      height: 7.75rem;
      line-height: 3.875rem;

      #multiSensorHiLModule1TextText1 {
        @include fontStyle(
          600,
          // 3.875rem,
          auto,
          2.5rem,
          3.875rem,
          0.06944rem,
          rgba(255, 255, 255, 0.85)
        );
      }

      #multiSensorHiLModule1TextText2 {
        opacity: 1;
        margin-top: 0.75rem;
        @include fontStyle(
          400,
          2rem,
          1.0625rem,
          2rem,
          0.06944rem,
          rgba(255, 255, 255, 0.65)
        );
      }
    }
  }

  .hercules {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6.75rem 12.8125rem 3.875rem;
    background: url("@/static/img/hercules_bg.png") no-repeat 100% 100%;
    background-size: cover;

    .left {
      width: 32rem;

      .h1 {
        color: rgba(255, 255, 255, 0.85);
        font-size: 2.25rem;
        font-weight: 600;
        line-height: 3.875rem;
      }

      .h2 {
        color: rgba(255, 255, 255, 0.65);
        font-size: 0.875rem;
        font-style: normal;
        font-weight: 400;
        line-height: 1.625rem;
      }
    }

    .right {
      width: 28.125rem;
      height: 25.125rem;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }

  .ourFuture {
    padding: 4.875rem 0;
    background: url("@/static/img/future_bg.png") no-repeat 100% 100%;
    background-size: cover;

    .title {
      color: rgba(255, 255, 255, 0.85);
      text-align: center;
      font-size: 2.25rem;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin-bottom: 3rem;
    }

    .cont {
      margin: 0 12.25rem;

      ul {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 1.25rem;

        li {
          padding: 1.5rem 2.75rem 1.875rem 2.75rem;
          border-radius: 0.25rem;
          background: linear-gradient(
            193deg,
            rgba(128, 186, 240, 0.1) 22.73%,
            rgba(16, 28, 60, 0.1) 72.38%
          );
          box-shadow: 0px 1.5rem 2.5rem 0px rgba(12, 12, 12, 0.4);
          backdrop-filter: blur(1.5625rem);

          flex: 1;
          min-width: 23%;

          // &:nth-child(1),
          // &:nth-child(2),
          // &:nth-child(3),
          // &:nth-child(4) {
          //   // width: 15%;
          //   width: 23.1%;
          // }

          // &:nth-child(5),
          // &:nth-child(6),
          // &:nth-child(7) {
          //   width: 23.1%;
          // }

          .img {
            width: 2.3125rem;
            height: 2.3125rem;
            margin-bottom: 1rem;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .h1 {
            color: rgba(255, 255, 255, 0.85);
            font-size: 1.25rem;
            font-style: normal;
            font-weight: 500;
            line-height: 2.25rem;
          }

          .h2 {
            color: rgba(255, 255, 255, 0.65);
            font-size: 0.875rem;
            font-style: normal;
            font-weight: 400;
            line-height: 1.5rem;
          }
        }

        .li1 {
          border: 1px solid red;
        }
      }
    }
  }
}

.en {
  .hercules {
    .h2 {
      line-height: 1.5 !important;
      // text-align: justify !important;
    }
  }
  .ourFuture {
    .h1,
    .h2 {
      line-height: 1.5 !important;
    }
    .h1 {
      height: 3rem !important;
      font-size: 0.955rem !important;
      font-weight: bold !important;
    }
    .h2 {
      margin-top: 0.5rem !important;
      // text-align: justify !important;
    }
  }
}
</style>
